import React from 'react';
import { Zoom, Fade } from 'react-reveal';
import { images } from '../../settings';

import './Comunicacao.scss';

class Comunicacao extends React.Component {
  render() {
    return (
      <div>

      
      <div className="comunicacao">
        <div className="comunicacao__conteudo">
          <div className="comunicacao__texto-imagem comunicacao-pb">
            <div className="comunicacao__texto">
              <h3 className="comunicacao__titulo green">
                <span className="gri_text">
                  Comunicação
                  <span className="gri_label comunicacao_gri-right">
                    GRI <b>102-43</b>
                  </span>
                </span>
              </h3>
              <p>
              Queremos ouvir o que nossos associados têm a dizer e dar transparência às informações. Para isso, utilizamos diferentes formas de comunicação. Em 2020, por conta da pandemia de coronavírus, nosso foco foi na comunicação online: aceleramos nossa digitalização, diversificamos as plataformas e conseguimos – segundo os próprios associados atestaram em pesquisas – estar ainda mais próximos deles.
              </p>
              <p>
              Pelo WhatsApp, totalizamos o envio de  <strong className="green">309 mensagens</strong> ao longo do ano, 272% mais que em 2019. Estreamos também no Telegram: foram 189 mensagens, com conteúdos dirigidos às instituições que seguem nossos códigos de autorregulação. Para entrar no grupo, basta se cadastrar pelo link <a href="https://t.me/ANBIMAbot" className="text_link">
                https://t.me/ANBIMAbot
                </a>
              </p>
              <p>
              Lançado em julho de 2019, o Workplace se consolidou no ano passado como canal de comunicação com o associado. Foram <strong className="green">619 posts</strong>, levando em primeira mão informações sobre tudo que acontece na ANBIMA, incluindo documentos para acesso exclusivo do associado. Em 2020, também iniciamos a transmissão de debates e entrevistas na forma de lives, com interações ao vivo entre o público e os participantes. 
              </p>
            </div>
            <div className="comunicacao__imagem-whats comunicacao__imagem-whats--desktop">
              <div className="comunicacao__imagem-whats">
                <img src={images.associados.WhatsMensagens} alt="Mensagens trocadas" className="carta"/>
                <img src={images.associados.WhatsMensagensPessoaFundo} alt="Mensagens trocadas" className="fundo"/>
                <img src={images.associados.WhatsMensagensPessoa} alt="Mensagens trocadas" className="desktop"/>
                <img src={images.associados.WhatsMensagensPessoaMobile} className="comunicacao__imagem-whats--mobile" alt="Mensagens trocadas" />
              </div>
              <div className="texto-imagem">
               {/*  <h5>
                  129 mensagens<br/>
                </h5> */}
                <h6>    
                  309 mensagens enviadas pelo WhatsApp
                </h6>
              </div>
              {/* <img src={images.associados.WhatsMensagens} alt="Mensagens trocadas" />
              <img className="whats-pessoa" src={images.associados.WhatsMensagensPessoa} alt="Mensagens trocadas" /> */}
            </div>
          </div>
            
          {/* <div className="comunicacao__imagem-whats comunicacao__imagem-whats--mobile">
            <img src={images.associados.WhatsMensagens} alt="Mensagens trocadas" />
            <img className="whats-pessoa" src={images.associados.WhatsMensagensPessoa} alt="Mensagens trocadas" />
          </div> */}
        </div>
      </div>
      <div className="comunicacao">
          <div className="comunicacao-associados-publicacao">
            <div className="div-imagem">
              <img className="estalo-joia1" src={images.associados.estalo_1} alt="Curtir" />
              <img className="estalo-joia2" src={images.associados.estalo_2} alt="Curtir" />
              <img className="estalo-joia3" src={images.associados.estalo_3} alt="Curtir" />
              <img className="joia" src={images.associados.joia} alt="Curtir" />
              <img className="joia-mobile" src={images.associados.joia_mobile} alt="Curtir" />
            </div>
            <div className="texto">
              <p className="texto2">619 posts</p>
              <p className="texto3">publicados no espaço <br/>do associado</p>
            </div>
          </div>
      </div>

      <div className="comunicacao">
        <div className="comunicacao-encontros-online">
          <div className="encontros-texto">
            <h1 className="titulo1">Encontros online</h1>
            <p>
            As visitas presenciais foram suspensas em março em decorrência do distanciamento social imposto pela pandemia e da adesão maciça ao home office, mas isso não nos impediu de ouvir as instituições.
            </p>
            <p>
             Os encontros passaram a ser virtuais: realizamos 69 deles, assegurando a manutenção do canal de relacionamento com o associado.
            </p>
            <h2 className="titulo2">
              69 visitas onlines
            </h2>
          </div>
          <div className="encontros-imagem">
            <img className="fundo-encontro" src={images.associados.funfo_encontro} alt="encontro" />
            <img className="encontro-menina" src={images.associados.encontro_menina} alt="encontro" />
            <img className="encontro-telefone" src={images.associados.encontro_telefone} alt="encontro" />
            <img className="encontro-som-tel-esquerda" src={images.associados.encontro_som_tel_esquerda} alt="encontro" />
            <img className="encontro-som-tel-direita" src={images.associados.encontro_som_tel_direita} alt="encontro" />
            <img className="fundo-encontro-mobile" src={images.associados.funfo_encontro_mobile} alt="encontro" />
          </div>
        </div>
      </div>

        {/* <div className="comunicacao">
        <div className="associados-grupos-posts">
          <div className="associados-grupos-posts__container">

            <div className="associados-posts-container">
              <div className="associados-posts-titulo">
                <div className="associados-posts-titulo__container-titulo">
                  <img src={images.associados.iconeLapis} alt="Ícone lápis" />
                  <h3 className="associados-posts-titulo__titulo">Publicação</h3>
                </div>
                <div className="associados-posts-titulo__risca"></div>
                <div className="associados-posts-titulo__qtd-posts">
                  <h3 className="associados-posts-titulo__titulo-qtd">
                    <span className="associados-posts-titulo__numero">
                      <Zoom>58</Zoom>
                    </span>{' '}
                    <span className="associados-posts-titulo__texto">
                      <Zoom>posts</Zoom>
                    </span>
                  </h3>
                  <h4 className="associados-posts-titulo__subtitulo-qtd">publicados no espaço do associado</h4>
                  <div className="associados-posts-titulo__like">
                    <img src={images.associados.likeIcon} alt="Ícone Curtir" />
                    <img className="icone-curtir icone-1" src={images.associados.likeIcon} alt="Ícone Curtir" />
                    <img className="icone-curtir icone-2" src={images.associados.likeIcon} alt="Ícone Curtir" />
                    <img className="icone-curtir icone-3" src={images.associados.likeIcon} alt="Ícone Curtir" />
                  </div>
                </div>
              </div>
            </div>


            <div className="associados-grupo">
              <div className="associados-grupo__header">
                <img src={images.associados.iconeGrupos} alt="Ícone Grupos" />
                <h3 className="associados-grupo__titulo">Por grupos</h3>
              </div>
              <Fade right cascade>
                <div className="associados-grupo-itens">
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--azul-escuro">
                      <span>26</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Distribuição</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--azul-claro">
                      <span>31</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Estruturação de Mercado de Capitais</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--verde-agua">
                      <span>18</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Gestão de Fundos Estruturados</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--laranja">
                      <span>28</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Gestão de Fundos Mútuos</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--amarelo">
                      <span>16</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Negociação</span>
                    </div>
                  </div>
                  <div className="associados-grupo-itens__linha">
                    <div className="associados-grupo-itens__numero associados-grupo-itens__numero--verde">
                      <span>18</span>
                    </div>
                    <div className="associados-grupo-itens__texto">
                      <span>Serviços Fiduciários</span>
                    </div>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>

        </div> */}
      </div>
    );
  }
}

export { Comunicacao };
